import styled from 'styled-components'

import breakpoints from '../../../theme/breakpoints'
import Link from '../../Link'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`

export const Column = styled.div`
  ${breakpoints.up('tablet')} {
    max-width: 20rem;
    &:first-child {
      margin-right: 2.4rem;
    }
  }
`

export const Title = styled.h5`
  ${(props) => props.theme.textStyles.text};
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.pureWhite};
  margin-bottom: 1.6rem;
  ${breakpoints.up('tablet')} {
    font-size: 1.4rem;
  }
`

export const CookiesSettings = styled.li`
  color: ${(props) => props.theme.colors.pureWhite};
  ${(props) => props.theme.textStyles.text};
  margin-bottom: 0.5rem;
  cursor: pointer;
`

export const ListWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  & a {
    color: ${(props) => props.theme.colors.pureWhite};
    text-decoration: none;
  }
`

export const ListItem = styled.li`
  margin-bottom: 0.5rem;
`

export const Lk = styled(Link)``
